import React from 'react';

import { Link } from 'components/FormComponents/FormComponents';
import Rating from 'components/Rating/Rating';
import { Tags } from 'components/Tags/Tags';
import { Image, CardInfoContainer, CardInfoHeader, CardName, CardCategory, CardWrapper } from './styles';

export const CardTitle = ({ name, categoryName, averageRating, tags, tagColor }) => (
  <CardInfoHeader>
    <CardName>{name}</CardName>
    {categoryName && <CardCategory>{categoryName}</CardCategory>}
    {averageRating >= 0 && <Rating readonly size={8} rating={averageRating} />}
    {tags && <Tags isTestTag tags={tags} tagColor={tagColor} />}
  </CardInfoHeader>
);

export const CardContainerLink = ({ image, link, height, children }) => {
  return (
    <CardWrapper height={height}>
      <Link to={link}>
        <Image image={image} />
        <CardInfoContainer pointerCursor>{children}</CardInfoContainer>
      </Link>
    </CardWrapper>
  );
};

export const CardContainer = ({ image, link, height, children }) => {
  return (
    <CardWrapper height={height}>
      <Link to={link}>
        <Image image={image} />
      </Link>
      <CardInfoContainer>{children}</CardInfoContainer>
    </CardWrapper>
  );
};
